import { DropdownItem, DropdownItemGroup, type DropdownItemProps } from '@atlaskit/dropdown-menu';
import { FormattedMessage } from 'react-intl-next';
import { type JSX } from 'react/jsx-runtime';

/*--Why am I seeing this--*/

type WhyAmISeeingThisProps = Omit<DropdownItemProps, 'children'>;

export const WhyAmISeeingThis = (props: WhyAmISeeingThisProps): JSX.Element => (
	<DropdownItem {...props}>
		<FormattedMessage
			id="post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label"
			defaultMessage="Why am I seeing this?"
			description="The text for the button which opens a modal showing the reasons a message has been displayed."
		/>
	</DropdownItem>
);

/*--Not interested--*/

type NotInterestedProps = Omit<DropdownItemProps, 'children'>;

export const NotInterested = (props: NotInterestedProps): JSX.Element => (
	<DropdownItem {...props}>
		<FormattedMessage
			id="post-office.ad-controls.dropdown-item.not-interested.label"
			defaultMessage="Not interested"
			description="The text for the button which removes a message from a placement."
		/>
	</DropdownItem>
);

/*--Remind me later--*/

type RemindMeLaterProps = Omit<DropdownItemProps, 'children'>;
export const RemindMeLater = (props: RemindMeLaterProps): JSX.Element => (
	<DropdownItem {...props}>
		<FormattedMessage
			id="post-office.ad-controls.dropdown-item.remind-me-later.label"
			defaultMessage="Remind me later"
			description="The text for the button which removes a message from a placement and makes it reappear at a later date."
		/>
	</DropdownItem>
);

type AddControlsDropdownProps = {
	onWhyAmISeeingThis: (
		e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
	) => void;
	onNotInterested: (
		e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
	) => void;
	onRemindMeLater: (
		e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
	) => void;
	showRemindMeLater?: boolean;
	showWhyAmISeeingThis?: boolean;
	customDropdownItems?: React.ReactNode[];
};

export const AdControlsDropdown = ({
	onWhyAmISeeingThis,
	onNotInterested,
	onRemindMeLater,
	showWhyAmISeeingThis = true,
	showRemindMeLater,
	customDropdownItems,
}: AddControlsDropdownProps): JSX.Element => (
	<DropdownItemGroup>
		{customDropdownItems?.map((item) => item)}
		{showRemindMeLater && (
			<RemindMeLater testId="ad-controls-dropdown-remind-me-later" onClick={onRemindMeLater} />
		)}
		<NotInterested testId="ad-controls-dropdown-not-interested" onClick={onNotInterested} />
		{showWhyAmISeeingThis && (
			<WhyAmISeeingThis
				testId="ad-controls-dropdown-why-am-I-seeing-this"
				onClick={onWhyAmISeeingThis}
			/>
		)}
	</DropdownItemGroup>
);
